// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import node css modules
import nodeStyles from '../nodeModuleStyles.css';

function NodeListItem({ node }) {
  return (
    <li>
      <Link to={`/nodes/${node._id}`}> {node.name}</Link>
    </li>
  )
}

NodeListItem.propTypes = {
  node: PropTypes.object.isRequired
}

export default NodeListItem;



// WEBPACK FOOTER //
// modules/node/components/NodeListItem.js.jsx